import { AutoCompleteOptionItem } from '@autocomplete-with-controls';

export function mapToOption<T = any>(
  data: T | any,
  checkDisabledCallback?: (item: any) => boolean,
  checkTooltipCallback?: (item: any) => string | null,
): AutoCompleteOptionItem<T> {
  return {
    option: data,
    ...(checkDisabledCallback ? { disabled: checkDisabledCallback(data) } : {}),
    ...(checkTooltipCallback ? { tooltip: checkTooltipCallback(data) } : {}),
  };
}

export function mapToOptions<T = any>(
  data: Array<T | any>,
  checkDisabledCallback?: (item: any) => boolean,
  checkTooltipCallback?: (item: any) => string | null,
): Array<AutoCompleteOptionItem<T>> {
  return data.map(option => mapToOption(option, checkDisabledCallback, checkTooltipCallback));
}
